import { Box, CircularProgress, Stack, Card, CardContent, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { DashboardSummaryRow } from "../../types/DashboardSummaryRow";
import { DashboardSummaryCard } from "../DashboardSummaryCard";
import * as _ from "underscore";


type DashboardSummaryProps = {

    header: string;
    subHeader?: string;
    footer: string;
    isLoading: boolean;
    refreshCount: number;
    rows: DashboardSummaryRow[ ];
    checkedItems: string[ ];
    disabledItems: string[ ];
    onItemsSelected( items: string[ ] ): void;

};


export const DashboardSummary : React.FC< DashboardSummaryProps > = ( props: DashboardSummaryProps ) => {

    const { header, subHeader, footer, isLoading, refreshCount, rows, checkedItems : initiallyCheckedItems, disabledItems, onItemsSelected } = props;

    const [ isSelectAll, setIsSelectAll ] = useState< boolean >( false );
    const [ selectedItems, setSelectedItems ] = useState< string[] >( [] );
    

    useEffect( () => {
        
        setSelectedItems( initiallyCheckedItems );
        const notEmptyItems = rows.filter( r => r.count > 0 ).map( m => m.item );
        const isSelectAll = _.isEqual( _.sortBy( initiallyCheckedItems ), _.sortBy( notEmptyItems ) );
        setIsSelectAll( isSelectAll );

    }, [ initiallyCheckedItems, rows ] );


    useEffect( () => {

        const notEmptyItems = rows.filter( r => r.count > 0 ).map( m => m.item );
        const isSelectAll = _.isEqual( _.sortBy( selectedItems ), _.sortBy( notEmptyItems ) );
        setIsSelectAll( isSelectAll );

        const timer = setTimeout( ( ) => { 
     
            onItemsSelected( selectedItems );
     
        }, 1000); 
     
        return () => { 
     
           clearTimeout( timer ); 
     
        };

    }, [ selectedItems ]);


    const handleOnItemDeselected = ( item: string ) => setSelectedItems( selectedItems => selectedItems.filter( i => i !== item )  ); 

    
    const handleOnItemSelected = ( item: string ) => setSelectedItems( [...selectedItems, item] ); 

    
    const handleSelectAll = ( checked : boolean ) => {

        setIsSelectAll( checked );

        if( checked ){

            const notEmptyItems = rows.filter( r => r.count > 0 ).map( m => m.item );
            setSelectedItems( notEmptyItems );

        } else {

            setSelectedItems( [] );

        }
        
    };


    return (

        <>
            {
                isLoading
                    ?
                <Box 
                    display="flex" 
                    alignItems="center"
                    justifyContent="center"
                    marginTop={ refreshCount === 0 ? 50 : 0 }
                >
                    <CircularProgress size="80px" sx={{color: '#e65400'}}/>
                </Box>
                    :
                <>
                    {
                        rows.length > 0
                            ?
                        <>
                    
                            <Stack direction="column">
                            
                                <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 }>

                                    <Card sx={{ width: '140px' }}>
                                        <CardContent sx={{ paddingLeft: '5px', paddingRight: '5px' }}>                                            
                                            <Typography align="center" sx={{ lineHeight: '40px', fontWeight: 'bold', borderBottom: '1px solid lightgray' }}>
                                                { header }
                                            </Typography>
                                            {subHeader && (
                                                <Typography align="center" sx={{ lineHeight: '40px', fontWeight: 'bold', borderBottom: '1px solid lightgray' }}>
                                                { subHeader }
                                            </Typography>
                                            )}
                                            <Typography align="center" sx={{ fontWeight: 'bold'}}>
                                                { footer }
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                    
                                    {

                                        rows.map( row =>
                                                                                    
                                            <DashboardSummaryCard 
                                                key={ row.item } 
                                                onItemDeselected={ handleOnItemDeselected } 
                                                onItemSelected={ handleOnItemSelected } 
                                                row={ row } 
                                                checked={ selectedItems.includes( row.item ) }
                                                disabled={ disabledItems.includes( row.item )}
                                            /> 

                                        )
                                        
                                    }

                                </Stack>

                                <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 }>

                                    <FormControlLabel control={
                                        <Checkbox onChange={ ( _, checked : boolean ) => handleSelectAll( checked ) } checked={ isSelectAll }/>
                                    } label="Select All" />

                                </Stack>
                                

                            </Stack>



                        </>
                            :
                        <h2>No data to display</h2>

                    }
                </>
            }

        </>

    );

};